import React from "react";

import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ChooseBank from "./ChooseBank";
import { useAppContext } from "../../context";
import ConsentDialog from "./ConsentDialog";
import ConvertCard from "./ConvertCard";
import Transfer from "./Transfer";



export default function DialogComponent() {
    const { step, setStep, setOpenPopUp, setBank } = useAppContext();

    const finishedTransfer = () => {
        // Logic to finalize the transfer process
        setOpenPopUp(false);
        setStep(1); 
        setBank(0);
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                width: "100%",
                minHeight: "650px",
                background: "#F6F8FC",
            }}
        >
            {/* LEFT SIDEBAR */}
            <Box
                sx={{
                    maxWidth: { xs: "100%", sm: 420, md: 410 }, // ნაკლები minWidth
                    background: "#EAF0F7",
                    p: 3,
                    flexShrink: 0,
                    display: "flex",
                    flexDirection: "column",
                    minHeight: { xs: "auto", md: "650px" },
                }}
            >
                <ConvertCard />
            </Box>


            {/* RIGHT SECTION */}
            <Box
                sx={{
                    flexGrow: 1,
                    backgroundColor: "#FFF",
                    p: { xs: 2, md: 4 },
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "650px",
                }}
            >
                <Typography
                    className="font-helviteca"
                    sx={{
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "#1C3553",
                        mb: 3,
                    }}
                >
                    აირჩიე სასურველი ბანკის ანგარიში
                </Typography>

                {/* STEP CONTAINER (HEIGHT FIXED + RESPONSIVE) */}
                <Box
                    sx={{
                        flexGrow: 1,
                        minHeight: { xs: "auto", md: "520px" },
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    {step === 1 && <ChooseBank />}
                    {step === 2 && <ConsentDialog />}
                    {step === 3 && <Transfer />}
                </Box>

                {/* BOTTOM BUTTONS */}
                <Box
                    sx={{
                        mt: 3,
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        gap: 2,
                        justifyContent: { xs: "center", sm: "flex-end" },
                    }}
                >
                    {step >= 2 && (
                        <Button
                            className="font-helviteca"
                            variant="contained"
                            sx={{
                                width: { xs: "100%", sm: "auto" },   // ← responsive width
                                background: "#02244DCC",
                                color: "#FFFFFF",
                                borderRadius: "10px",
                                px: 4,
                                py: 1.2,
                            }}
                            onClick={() => setStep(step - 1)}
                        >
                            უკან დაბრუნება
                        </Button>
                    )}

                    <Button
                        className="font-helviteca"
                        variant="contained"
                        sx={{
                            width: { xs: "100%", sm: "auto" },    // ← responsive width
                            background: "#FF5440",
                            color: "#FFFFFF",
                            borderRadius: "10px",
                            px: 4,
                            py: 1.2,
                        }}
                    onClick={() => {setStep(step + 1); step === 3 && finishedTransfer();}}
                    >
                        {step === 3 ? "დასრულება" : "გაგრძელება"}
                    </Button>
                </Box>

            </Box>
        </Box>


    );
}
